export default "__VITE_ASSET__ccb9d4c9__"